<template>
  <v-menu bottom offset-y :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        text
        :elevation="0"
        class="mt-1 px-1"
        style="min-width: 30px"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <v-list-item>
        <v-list-item-icon class="mr-1">
          <v-icon>mdi-magnify</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          <v-row align="center">
            <v-col>
              {{ $t ('Zoom') }}
            </v-col>
            <v-col>
              <div style="border: solid 1px #ddd">
                <v-btn text small style="min-width: 0px" class="mr-2" @click="decrementarZoom"><v-icon small>mdi-minus</v-icon></v-btn>
                <div class="d-inline-block" @click="restablecerZoom" style="cursor: pointer"> {{ porcentajeZoom }}</div>
                <v-btn text small style="min-width: 0px" class="ml-2" @click="incrementarZoom"><v-icon small>mdi-plus</v-icon></v-btn>
              </div>
            </v-col>
          </v-row>
        </v-list-item-title>
      </v-list-item>

      <v-list-item link @click="conmutarVistaCompacta">
        <v-list-item-icon class="mr-1">
          <v-icon v-if="vistaCompacta" color="gray">mdi-checkbox-marked</v-icon>
          <v-icon v-else color="gray">mdi-checkbox-blank-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          {{ $t ('Vista compacta') }}
        </v-list-item-title>
      </v-list-item>
    </v-list>

  </v-menu>

</template>

<script>
export default {
  props: {
    TablaDatosApi: {
      type: Object,
      required: true,
    }
  },
  computed: {
    porcentajeZoom() {
      return Math.round (this.TablaDatosApi.valorZoom * 100) + '%';
    },
    vistaCompacta() {
      return this.TablaDatosApi.vistaCompacta;
    }
  },
  methods: {
    decrementarZoom () {
      if (this.TablaDatosApi.valorZoom > 0.5)
        this.TablaDatosApi.valorZoom -= 0.04;
    },
    incrementarZoom () {
      if (this.TablaDatosApi.valorZoom < 2)
        this.TablaDatosApi.valorZoom += 0.04;
    },
    restablecerZoom () {
      this.TablaDatosApi.valorZoom = 1;
    },
    conmutarVistaCompacta () {
      this.TablaDatosApi.vistaCompacta = !this.TablaDatosApi.vistaCompacta;
    }
  }
}
</script>

<style>

</style>